import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './languages/en'
import ro from './languages/ro'

Vue.use(VueI18n)

const messages = {
  en,
  ro
}

const i18n = new VueI18n({
  locale: 'ro', // set locale
  messages // set locale messages
});


export default i18n